/* 배너 버튼 글자 세로 정렬 — 실측 보정 (2026-09-08)

   ⚠️⚠️ **왜 JS 인가.** 이 정렬은 폰트의 세로 메트릭에 딸려 있고 그 값이 플랫폼마다 다르게
      해석된다(macOS 는 hhea · Windows 는 OS/2 usWin*). CSS 로 푸는 정답은 `text-box`
      (cap~베이스라인 트림)인데 **Chrome 133 미만·Firefox 는 지원하지 않는다.** 그 환경에서는
      손으로 넣은 보정값이 남고, 그 값은 특정 환경에서 잰 것이라 다른 환경에서는 오차를 키운다.
      → 지원 환경은 CSS 가 정확히 처리하고, **미지원 환경만 여기서 실측해 맞춘다.**

   ⚠️ `text-box` 를 지원하면 **아무것도 하지 않는다** — 이미 0.00px 로 맞고(실측),
      건드리면 이중 보정이 된다.
   ⚠️ 보정은 `padding-bottom` 으로 한다. flex 중앙정렬에서 글자 중심은
      `H/2 + (paddingTop − paddingBottom)/2` 라 **차이의 절반**만 움직인다 → 오차 d 를 없애려면
      `paddingBottom = 2d`. `transform: translateY` 로 하지 말 것(소수 픽셀 이동은 글자를 흐린다).
   ⚠️ `box-sizing: border-box` 라 높이는 그대로 유지된다.
   ⚠️ 폰트가 늦게 오면 값이 달라지므로 `document.fonts.ready` 뒤에 재고, 화면 폭이 바뀌면
      (버튼 크기·글자 크기가 브레이크포인트에서 달라진다) 다시 잰다.
   ⚠️ **`>= 0.25px` 만 보정한다** — 그 아래는 육안으로 구분되지 않고, 매 실행마다 값이
      미세하게 흔들려 무한 재보정이 될 수 있다. */
(() => {
  const SUPPORTS_TEXT_BOX =
    window.CSS && CSS.supports && CSS.supports('text-box', 'trim-both cap alphabetic');
  if (SUPPORTS_TEXT_BOX) return;

  const MIN = 0.25;
  const ctx = document.createElement('canvas').getContext('2d');

  const fix = (btn) => {
    const label = btn.querySelector('.nmb-btn__label');
    if (!label) return;
    const text = label.textContent.trim();
    if (!text) return;

    // 보정을 걷어낸 상태에서 재야 누적되지 않는다
    btn.style.paddingTop = '0px';
    btn.style.paddingBottom = '0px';

    const cs = getComputedStyle(btn);
    ctx.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
    const tm = ctx.measureText(text);
    if (!tm.fontBoundingBoxAscent) return; // 구형 엔진 — 지표가 없으면 손대지 않는다

    const btnRect = btn.getBoundingClientRect();
    const labelRect = label.getBoundingClientRect();

    // 라벨 박스 위 = 라인박스 위(트림 미지원 분기이므로) → 베이스라인은 ascent 만큼 아래
    const baseline = labelRect.top - btnRect.top + tm.fontBoundingBoxAscent;
    const inkTop = baseline - tm.actualBoundingBoxAscent;
    const inkBottom = baseline + tm.actualBoundingBoxDescent;
    const offset = (inkTop + inkBottom) / 2 - btnRect.height / 2;

    if (Math.abs(offset) < MIN) return;
    // offset > 0 = 글자가 아래로 치우침 → 아래쪽 패딩을 키워 위로 올린다
    btn.style.paddingBottom = `${(offset * 2).toFixed(2)}px`;
  };

  const run = () => document.querySelectorAll('.nmb-btn').forEach(fix);

  const start = () => {
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    let t;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(run, 150);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
